import {
  REQUEST_REDIRECTION_PARAMS,
  RECEIVE_REDIRECTION_PARAMS,
  RECEIVE_ERROR_REDIRECTION_PARAMS,
  RESET_ERROR,
  RESET_REDIRECTION,
  RESET_REDIRECTION_PARAMS
} from "../actions/redirect";

const initialState = { redirecting: false, redirectError: undefined };

export default function redirectionReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_REDIRECTION_PARAMS:
      return { ...state, redirecting: true };
    case RECEIVE_REDIRECTION_PARAMS:
      return {
        ...state,
        redirecting: true,
        redirectParams: action.redirectParams
      };
    case RECEIVE_ERROR_REDIRECTION_PARAMS:
      return { ...state, redirecting: false, redirectError: action.message };
    case RESET_REDIRECTION:
      return { ...state, redirecting: false };
    case RESET_REDIRECTION_PARAMS:
      return { ...state, redirectParams: undefined };
    case RESET_ERROR:
      return { ...state, redirectError: undefined };
    default:
      return state;
  }
}
